import { PlanTable } from './PlanTable';

export default PlanTable;